"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/ConversationBox/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactwaypoint = require('react-waypoint');






var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _time = require('shared/services/time');
var _conversation = require('shared/services/conversation');

var _ChatNotice = require('web/components/Upgrade/ChatNotice'); var _ChatNotice2 = _interopRequireDefault(_ChatNotice);
var _BeginningMarker = require('web/components/Conversation/BeginningMarker'); var _BeginningMarker2 = _interopRequireDefault(_BeginningMarker);
var _LoadingIndicator = require('web/components/Conversation/LoadingIndicator'); var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
var _NewMessagesMarker = require('web/components/Conversation/NewMessagesMarker'); var _NewMessagesMarker2 = _interopRequireDefault(_NewMessagesMarker);
var _Message = require('web/components/Conversation/Message'); var _Message2 = _interopRequireDefault(_Message);
var _TranslationPill = require('web/components/Conversation/Message/TranslationPill'); var _TranslationPill2 = _interopRequireDefault(_TranslationPill);
var _LanguageOfferDialog = require('web/components/Conversation/LanguageOfferDialog'); var _LanguageOfferDialog2 = _interopRequireDefault(_LanguageOfferDialog);

var _JumpBtn = require('web/components/Conversation/JumpBtn'); var _JumpBtn2 = _interopRequireDefault(_JumpBtn);
var _ScheduledMessage = require('web/components/Conversation/ScheduledMessage'); var _ScheduledMessage2 = _interopRequireDefault(_ScheduledMessage);





var _hooks = require('./hooks');

const containerStyles = { flexDirection: 'column-reverse' }
const topSpacerStyles = { flexShrink: 0 }
const makeScrollbarAwareStyle = (containerDOM) => containerDOM
  ? { paddingRight: containerDOM.offsetWidth - containerDOM.clientWidth }
  : undefined











































const NO_SCHEDULED = []

const ConversationBox = ({
  onLoadBelow,
  onLoadAbove,
  isLoadingBelow,
  isLoadingAbove,
  messageBatches,
  relevantBatchIdx,
  latestBatchIdx,
  relevantMessageKey,
  highlightedMessageKey,
  currentUserKey,
  isCurrentUserActive,
  subscribers,
  onDelete,
  onAddReaction,
  onRemoveReaction,
  onCopyMessageLink,
  onReply,
  onJumpToMessage,
  readOnly,
  recallOnlyAwaitingConsent,
  onAbortSendFile,
  onRetrySendMessage,
  onRetrySendFile,
  conversationKey,
  onMarkMessageSeen,
  lastSeenMessageKey,
  lastSeenTime,
  unreadMessagesCount = 0,
  totalMessagesCount,
  blobjectKey,
  className,
  scheduledFeed = NO_SCHEDULED,
  onScheduledAction,
  showTranslations = false,
  pillMessageKey,
}) => {
  const [cachedLastSeenMessageKey, setCachedLastSeenMessageKey] = _react.useState(null)
  // The server's unread count when the line was placed, which the rows on
  // screen can fall short of until older ones load; the jump pill says it too.
  const [cachedUnreadCount, setCachedUnreadCount] = _react.useState.call(void 0, 0)
  const unreadCountRef = _react.useRef.call(void 0, unreadMessagesCount)
  unreadCountRef.current = unreadMessagesCount
  const cacheLastSeenMessageKey = _react.useCallback.call(void 0, (key) => {
    setCachedLastSeenMessageKey(key)
    setCachedUnreadCount(unreadCountRef.current)
  }, [])
  const { messages, setLatestBatch, isOnLatestBatch } =
    _hooks.useBatchSwitch.call(void 0, messageBatches, relevantBatchIdx, latestBatchIdx)

  const handleViewMessage = _hooks.useViewMessage.call(void 0, onMarkMessageSeen, currentUserKey)
  const messagesCount = messages.length
  const hasMessages = !!messagesCount
  const newLine = _conversation.newMessagesLine.call(void 0, messages, cachedLastSeenMessageKey, currentUserKey, cachedUnreadCount)

  const containerRef = _react.useRef(null)
  const getContainerDOM = () => containerRef.current

  const scrollbarAwareStyle = makeScrollbarAwareStyle(getContainerDOM())
  const scrollToBottom = _hooks.useScrollToBottom.call(void 0, { setLatestBatch, getContainerDOM })
  const scrollToMessage = _hooks.useScrollToMessage.call(void 0, { getContainerDOM })

  const hasSettledScroll = _hooks.useInitialScroll.call(void 0, {
    getContainerDOM,
    hasMessages,
    relevantMessageKey,
    scrollToMessage,
  })

  const {
    renderTopBoundaryWaypoint,
    renderBottomBoundaryWaypoint,
  } = _hooks.useBoundaryHitbox.call(void 0, {
    messages,
    onLoadBelow,
    onLoadAbove,
    hasSettledScroll,
    getContainerDOM,
  })

  const latestMessage =
    ((_nullishCoalesce(_optionalChain([messages, 'optionalAccess', _ => _[0], 'optionalAccess', _2 => _2.Sequence]), () => ( 0))) >= totalMessagesCount && _optionalChain([messages, 'optionalAccess', _3 => _3[0]])) || {} 
  const isLatestMessageFromMe = latestMessage.UserKey === currentUserKey
  const maxMessageSequence = Math.max(
    totalMessagesCount,
    latestMessage.Sequence || 0,
  )
  const { isAtBottom, renderStickyBottomWaypoint } = _hooks.useStickyBottom.call(void 0, {
    maxMessageSequence,
    isLatestMessageFromMe,
    isCurrentUserActive,
    cachedLastSeenMessageKey,
    hasSettledScroll,
      scrollToBottom,
    getContainerDOM,
  })

  const enteringMessageKey = _hooks.useEnteringMessage.call(void 0, messages, hasSettledScroll)
  const currentDay = _hooks.useCurrentDayPill.call(void 0, containerRef, messagesCount)
  const handleJumpToBottom = _react.useCallback.call(void 0, 
    () => scrollToBottom({ shouldAnimate: true }),
    [scrollToBottom],
  )

  _hooks.useLastSeenMessageCache.call(void 0, {
    lastSeenMessageKey,
    cachedLastSeenMessageKey,
    setCachedLastSeenMessageKey: cacheLastSeenMessageKey,
    isCurrentUserActive,
    unreadMessagesCount,
    hasSettledScroll,
    isAtBottom,
  })

  return (
    _react2.default.createElement('div', { className: "conversation-box--wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 195}}
      , _react2.default.createElement('div', {
        ref: containerRef,
        style: containerStyles,
        className: _classBuilder2.default.call(void 0, "conversation-box", className), __self: this, __source: {fileName: _jsxFileName, lineNumber: 196}}

        , _react2.default.createElement(_ChatNotice2.default, { blobjectKey: blobjectKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 201}} )
        ,  renderStickyBottomWaypoint(hasMessages && isOnLatestBatch) 
        ,  renderBottomBoundaryWaypoint() 
        /* The list runs bottom-up, so these follow the latest message. */
        ,  isOnLatestBatch && scheduledFeed.map(item => (
          _react2.default.createElement(_ScheduledMessage2.default, {
            key: item.MessageKey,
            item: item,
            onAction: onScheduledAction,
            onJumpToMessage: onJumpToMessage, __self: this, __source: {fileName: _jsxFileName, lineNumber: 206}}
          )
        ))
        ,  isLoadingBelow
          ? _react2.default.createElement(_LoadingIndicator2.default, { isBottom: true, style: scrollbarAwareStyle, __self: this, __source: {fileName: _jsxFileName, lineNumber: 214}} )
          : null
        
        ,  messages.map((m, i) => (
          _react2.default.createElement(_react2.default.Fragment, { key: m.MessageKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 218}}
            ,  hasSettledScroll &&
              _time.isAfter.call(void 0, m.SentAt, lastSeenTime) &&
              isCurrentUserActive
              // Left inline on purpose (TM-559): react-waypoint is a PureComponent
              // that re-checks its position on every prop change, and mark-seen
              // relies on that re-check after layout shifts that fire no scroll.
              // oxlint-disable-next-line react-perf/jsx-no-new-function-as-prop -- intentional, see above
              ? _react2.default.createElement(_reactwaypoint.Waypoint, { onEnter: () => handleViewMessage(m), __self: this, __source: {fileName: _jsxFileName, lineNumber: 226}} )
              : null
            
            ,  _optionalChain([newLine, 'optionalAccess', _4 => _4.index]) === i
              ? _react2.default.createElement(_NewMessagesMarker2.default, { count: newLine.count, __self: this, __source: {fileName: _jsxFileName, lineNumber: 230}} )
              : null
            
            /* Before the row in the DOM: the column is reversed, so the
                pill shows under its message. */
            ,  m.MessageKey === pillMessageKey
              ? _react2.default.createElement(_TranslationPill2.default, { conversationKey: conversationKey, messageKey: m.MessageKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 236}} )
              : null
            
            , _react2.default.createElement(_Message2.default, {
              currentUserKey: currentUserKey,
              subscribers: subscribers,
              highlighted: _conversation.rowShowsMessage.call(void 0, m, highlightedMessageKey),
              onDelete: onDelete,
              onAddReaction: onAddReaction,
              onRemoveReaction: onRemoveReaction,
              onCopyMessageLink: onCopyMessageLink,
              onReply: onReply,
              onJumpToMessage: onJumpToMessage,
              readOnly: readOnly,
              recallOnlyAwaitingConsent: recallOnlyAwaitingConsent,
              onRetrySendMessage: onRetrySendMessage,
              onRetrySendFile: onRetrySendFile,
              onAbortSendFile: onAbortSendFile,
              conversationKey: conversationKey,
              isLastMessage: i === 0,
              isEntering: m.MessageKey === enteringMessageKey,
              showTranslations: showTranslations,
              ...m, __self: this, __source: {fileName: _jsxFileName, lineNumber: 239}}
            )
            ,  m.Sequence === 1 ? _react2.default.createElement(_BeginningMarker2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 260}} ) : null 
          )
        ))
        ,  isLoadingAbove ? _react2.default.createElement(_LoadingIndicator2.default, { isTop: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 263}} ) : null 
        ,  renderTopBoundaryWaypoint() 
        , _react2.default.createElement('div', { className: "conversation-box--spacer", style: topSpacerStyles, __self: this, __source: {fileName: _jsxFileName, lineNumber: 265}} )
      )
      ,  currentDay && (
        _react2.default.createElement('div', { className: "conversation-box--day-pill", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 268}}
          , _react2.default.createElement('span', { className: "conversation-box--day-pill--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 269}},  currentDay )
        )
      )
      ,  !isAtBottom && hasSettledScroll &&
        (unreadMessagesCount || highlightedMessageKey)
        ? (
            _react2.default.createElement(_JumpBtn2.default, {
              style: scrollbarAwareStyle,
              onClick: handleJumpToBottom,
              unreadMessagesCount: unreadMessagesCount, __self: this, __source: {fileName: _jsxFileName, lineNumber: 275}}
            )
          )
        : null
      
      , _react2.default.createElement(_LanguageOfferDialog2.default, { conversationKey: conversationKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 283}} )
    )
  )
}

exports. default = ConversationBox
